import { IModalApplicationMailingsUI } from './types'

import imgEmpty from '@img/empty.svg'
import { IconClearClose } from '@img/icons'

import { Empty, Flex, Modal, Button, Table } from '@ui/index'


/** Рассылки по заявке */
export const ModalApplicationMailingsUI = ({
    isOpen, actionMailingsList, onSelectString, handleButtonSended, handleButtonCancel,
}: IModalApplicationMailingsUI) => {
    return <>
        <Modal isOpen={isOpen} isEsc isWrapper onCancel={handleButtonCancel}>
            <Flex className='modal_container'>
                <Flex className='modal_container-header' flexDirection='row' alignItems='center' justifyContent='space-between'>
                    <h4>Рассылки...</h4>
                    <Button size='sm' variant='icon' onClick={handleButtonCancel}><IconClearClose /></Button>
                </Flex>

                <Flex gap='4px' className='modal_container-body'>
                    <Flex gap='6px' className='modal_container-content' height='320px'>
                        <Table.Content gap='2px'>
                            {actionMailingsList.value.length === 0
                                ? <Empty image={imgEmpty} />
                                : actionMailingsList.value.map((item, index) => (
                                    <Table.RowCheckBox key={index + 1} 
                                        headerWidth='40px' isSelected={item.isCheck}
                                        header={(index + 1).toString()}
                                        onClick={() => onSelectString(item.id)}
                                    >
                                        <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                            <p>{item.name}</p>
                                        </div>
                                    </Table.RowCheckBox>
                                ))
                            }
                        </Table.Content>
                    </Flex>

                    <div style={{gap: '6px', display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <Button variant='primaryDark' width='100%' onClick={handleButtonCancel}>ОТМЕНА</Button>
                        <Button width='100%' onClick={handleButtonSended}>ОТПРАВИТЬ</Button>
                    </div>
                </Flex>
            </Flex>
        </Modal>
    </>
}